import { isNullOrUndefined } from "../../helper/utils";
import { setUrlParam } from "../../services/UrlService";

const ApiService = require("../../services/ApiService");

const state = () => ({
    shippingCountries: [],
    shippingCountryId: null
});

const mutations =
    {
        setShippingCountries(state, shippingCountries)
        {
            state.shippingCountries = shippingCountries;
        },

        setShippingCountryId(state, shippingCountryId)
        {
            if (shippingCountryId !== state.shippingCountryId && !App.isSSR)
            {
                document.dispatchEvent(new CustomEvent("afterShippingCountryChanged", { detail: shippingCountryId }));
            }

            state.shippingCountryId = shippingCountryId;
        }
    };

const actions =
    {
        selectShippingCountry({ commit, state }, { shippingCountryId, openBasketPreview })
        {
            return new Promise((resolve, reject) =>
            {
                const oldShippingCountryId = state.shippingCountryId;

                commit("setShippingCountryId", shippingCountryId);
                ApiService.post("/rest/io/shipping/country", { "shippingCountryId": shippingCountryId })
                    .done(data =>
                    {
                        if (isNullOrUndefined(oldShippingCountryId) || oldShippingCountryId !== data)
                        {
                            if (openBasketPreview)
                            {
                                setUrlParam({ openBasketPreview: 1 });
                            }

                            window.location.reload();
                        }
                        resolve(data);
                    })
                    .fail(error =>
                    {
                        commit("setShippingCountryId", oldShippingCountryId);
                        reject(error);
                    });
            });
        }
    };

const getters =
    {
        getCountryName: state => countryId =>
        {
            if (countryId > 0)
            {
                const country = state.shippingCountries.find(country => country.id === countryId);

                if (!isNullOrUndefined(country))
                {
                    return country.currLangName;
                }
            }

            return "";
        },

        // Gegenstueck zu getCountryName fuer das Bundesland. Ceres liest hier
        // country.states.find(...).name ohne Absicherung - fehlt das States-Array
        // oder der Eintrag, wirft das. Deshalb beide Zugriffe geprueft.
        getStateName: state => (countryId, stateId) =>
        {
            if (countryId > 0 && stateId > 0)
            {
                const country = state.shippingCountries.find(country => country.id === countryId);

                if (!isNullOrUndefined(country) && Array.isArray(country.states))
                {
                    const countryState = country.states.find(entry => entry.id === stateId);

                    if (!isNullOrUndefined(countryState))
                    {
                        return countryState.name;
                    }
                }
            }

            return "";
        }
    };

export default
{
    state,
    mutations,
    actions,
    getters
};
